import { createAction } from 'redux-actions';

export default function createAsyncActions(type, payloadCretor = null, metaCreator = null) {
  return {
    pending: createAction(`${type}_PENDING`, payloadCretor, metaCreator),
    fulfilled: createAction(`${type}_FULFILLED`, payloadCretor, metaCreator),
    rejected: createAction(`${type}_REJECTED`, payloadCretor, metaCreator)
  };
}
